import { formatDayMonth, formatWeekday } from '@/shared/lib/formatDate'
import { useTranslation } from '@/shared/i18n/useTranslation'
import type { TranslationKey } from '@/shared/i18n/types'
import styles from './GreetingRow.module.css'

type GreetingRowProps = {
  displayName: string
  /** The one line under the greeting. Callers own the wording — the survivor
   *  home counts games, the frozen fantasy home counts leagues. */
  subtitle:    string
}

function greetingKey(hour: number): TranslationKey {
  if (hour < 12) return 'greeting.morning'
  if (hour < 18) return 'greeting.afternoon'
  return 'greeting.evening'
}

export function GreetingRow({ displayName, subtitle }: GreetingRowProps) {
  const { t, language } = useTranslation()

  const now       = new Date()
  const firstName = displayName.split(' ')[0] ?? displayName
  const weekday   = formatWeekday(now, language)

  return (
    <div className={styles.row}>
      <div>
        <p className={styles.greeting}>
          {t(greetingKey(now.getHours()))}, {firstName}
        </p>
        <p className={styles.sub}>{subtitle}</p>
      </div>

      <div className={styles.dateBlock}>
        <span>{weekday.charAt(0).toUpperCase() + weekday.slice(1)}</span>
        <span>{formatDayMonth(now, language)}</span>
      </div>
    </div>
  )
}
